import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import style from "./style.css";

export default class Button extends Component {
  render() {
    const finalRootClass = classnames(style.root, this.props.rootClassname);
    return <div className={finalRootClass}>{this.props.children}</div>;
  }
}

Button.propTypes = {
  rootClassname: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Wrapper/index.js